import OrderGet from "@/src/interfaces/sales/order-get"
import SvgConfirmed from '@/src/assets/svgs/order-status/confirmed.svg'
import SvgNotPlaced from '@/src/assets/svgs/order-status/not-placed.svg'
import SvgPlacedSite from '@/src/assets/svgs/order-status/placed-site.svg'
import SvgPlacedWhatsApp from '@/src/assets/svgs/order-status/placed-whatsapp.svg'
import SvgPrepared from '@/src/assets/svgs/order-status/prepared.svg'
import SvgDispatched from '@/src/assets/svgs/order-status/dispatched.svg'
import SvgCanceled from '@/src/assets/svgs/order-status/canceled.svg'
import SvgExpired from '@/src/assets/svgs/order-status/expired.svg'
import SvgCheckGray from '@/src/assets/svgs/order-status/check-gray.svg'

export class OrderStatusMessages {
    public static getStatusSubMessage(status: OrderGet.OrderStatus, msg?: string, autoClosed?: boolean) {
        if (this.canShowByAutoClosed(status, autoClosed))
            return 'Seu pedido foi finalizado.'

        switch (status) {
            case 'NotPlaced':
                return 'Seu pedido ainda não foi efetuado.'
            case 'PlacedByWhatsApp':
                return 'Pedido realizado! Agora é só encaminhá-lo pelo WhatsApp do estabelecimento.'
            case 'PlacedBySiteApp':
                return 'Seu pedido foi realizado e está aguardando a confirmação do estabelecimento.'
            case 'Confirmed':
                return 'Seu pedido foi confirmado e está sendo preparado.'
            case 'Prepared':
                return 'Seu pedido está pronto para retirada!'
            case 'Dispatched':
                return 'Seu pedido está a caminho!'
            case 'Delivered':
                return 'Seu pedido foi entregue. Aproveite!'
            case 'Canceled':
                return `Seu pedido foi cancelado pelo estabelecimento. ${msg}`
            case 'Expired':
                return 'Seu pedido não foi confirmado pelo estabelecimento a tempo.'
            default:
                return 'Status desconhecido. Entre em contato com o suporte.'
        }
    }

    public static getProgressBarValue(status: OrderGet.OrderStatus | undefined, autoClosed?: boolean) {
        if (this.canShowByAutoClosed(status, autoClosed))
            return 100

        switch (status) {
            case 'NotPlaced':
                return 0
            case 'PlacedByWhatsApp':
            case 'PlacedBySiteApp':
                return 20
            case 'Confirmed':
                return 40
            case 'Dispatched':
                return 60
            case 'Prepared':
                return 70
            case 'Delivered':
            case 'Canceled':
            case 'Expired':
                return 100
            default:
                return 0
        }
    }

    public static getFriendlyStatusMessage(status: OrderGet.OrderStatus, autoClosed?: boolean) {
        if (this.canShowByAutoClosed(status, autoClosed))
            return 'Seu pedido foi finalizado'

        switch (status) {
            case 'NotPlaced':
                return 'Pedido ainda não realizado'
            case 'PlacedByWhatsApp':
                return 'Pedido feito via WhatsApp'
            case 'PlacedBySiteApp':
                return 'Pedido feito pelo site ou app'
            case 'Confirmed':
                return 'Pedido confirmado pelo estabelecimento'
            case 'Prepared':
                return 'Pedido preparado e pronto para envio'
            case 'Dispatched':
                return 'Pedido a caminho do destino'
            case 'Delivered':
                return 'Pedido entregue com sucesso'
            case 'Canceled':
                return 'Pedido foi cancelado'
            case 'Expired':
                return 'Tempo limite do pedido foi excedido'
            default:
                return 'Status do pedido desconhecido'
        }
    }

    public static getStatusMessage(status: OrderGet.OrderStatus, autoClosed?: boolean) {
        if (this.canShowByAutoClosed(status, autoClosed))
            return 'Finalizado'

        switch (status) {
            case 'NotPlaced':
                return 'Não efetuado'
            case 'PlacedByWhatsApp':
                return 'Efetuado WhatsApp'
            case 'PlacedBySiteApp':
                return 'Efetuado Site/App'
            case 'Confirmed':
                return 'Confirmado'
            case 'Prepared':
                return 'Pronto'
            case 'Dispatched':
                return 'Saiu para entrega'
            case 'Delivered':
                return 'Entregue'
            case 'Canceled':
                return 'Cancelado'
            case 'Expired':
                return 'Expirado'
            default:
                return 'Não definido'
        }
    }

    public static getStatusSvg(status: OrderGet.OrderStatus, autoClosed?: boolean): JSX.Element {
        if (this.canShowByAutoClosed(status, autoClosed))
            return <SvgCheckGray />

        switch (status) {
            case 'NotPlaced':
                return <SvgNotPlaced />
            case 'PlacedByWhatsApp':
                return <SvgPlacedWhatsApp />
            case 'PlacedBySiteApp':
                return <SvgPlacedSite />
            case 'Confirmed':
                return <SvgConfirmed />
            case 'Prepared':
                return <SvgPrepared />
            case 'Dispatched':
                return <SvgDispatched />
            case 'Delivered':
                return <SvgCheckGray />
            case 'Canceled':
                return <SvgCanceled />
            case 'Expired':
                return <SvgExpired />
            default:
                return <></>
        }
    }

    private static canShowByAutoClosed(status: OrderGet.OrderStatus = 'NotPlaced', autoClosed?: boolean) {
        return status !== 'Delivered' && status !== 'Expired' && status !== 'Canceled' && autoClosed
    }
}